import { createSelector } from 'redux-orm';
import isUndefined from 'lodash/isUndefined';

import orm from '../orm';
import { selectCurrentUserId } from './users';
import { isLocalId } from '../utils/local-id';
import Config from '../constants/Config';

export const selectRoleByCode = createSelector(
  orm,
  (_, code) => code,
  ({ Role }, code) => {
    const roleModel = Role.all()
      .toModelArray()
      .find((role) => role.code === code);

    return roleModel?.ref || null;
  },
);

export default {
  selectRoleByCode,
};
